import React from "react"
const Spinner = props => {
	return (
      props.enabled && 
      <div className="ep2019-spinner-wrapper">
         <div className="ep2019-map-spinner" />
         <div>...caricamento...</div>
      </div>
	);
};
export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js